import dynamic from "next/dynamic";

export type BlockProps<T = any> = { data: T };

const Hero = dynamic(() => import("../section/Hero") );
const NosCibles = dynamic(() => import("../section/NosCibles") );
const NosOffres = dynamic(() => import("../section/NosOffres") );
const Cta = dynamic(() => import("../section/Cta") );
const Avantage = dynamic(() => import("../section/Avantage") );
const FormuleSection = dynamic(() => import("../section/FormuleSection") );
const BoissonSection = dynamic(() => import("../section/BoissonSection") );
const SelectionSection = dynamic(() => import("../section/SelectionSection") );
const Remise = dynamic(() => import("../section/Remise") );
const NosFormules = dynamic(() => import("../section/Plaisir-Gourmet") );
const DevenirPartenaireSection = dynamic(() => import("../section/Devenir-Partenaire") );
const AvantagesEntreprise = dynamic(() => import("../section/AvantagesEntreprise") );
const PourQuiSection = dynamic(() => import("../section/Pour-qui") );
const ContactezNous = dynamic(() => import("../section/Contactez-nous") );
const FAQ = dynamic(() => import("../section/FAQ") );
const Formulaire = dynamic(() => import("../section/Formulaire") );
const HeroConcept = dynamic(() => import("../section/HeroConcept") );
const Solutions = dynamic(() => import("../section/NotreSolution") );
const Etapes = dynamic(() => import("../section/Etapes") );
const PresentationContact = dynamic(() => import("../section/PresentationContact") );
const FormulaireContactAgence = dynamic(() => import("../section/FormulaireContactAgence") );
const AvantagesRapides = dynamic(() => import("../section/AvantagesRapides") );
const FormuleSectionGourmet = dynamic(() => import("../section/FormuleSectionGourmet") );
const AccordeonAgence = dynamic(() => import("../section/AccordeonAgence") );
const NosProfils = dynamic(() => import("../section/NosProfils") );

export const BLOCKS_REGISTRY: Record<string, React.ComponentType<BlockProps>> = {
  "blocks.hero":   Hero as any,
  "blocks.hero-concept":   HeroConcept as any,
  "blocks.nos-cibles": NosCibles as any,
  "blocks.nos-offres": NosOffres as any,
  "blocks.cta": Cta as any,
  "blocks.nos-avantages": Avantage as any,
  "blocks.nos-formules": FormuleSection as any,
  "blocks.boissons": BoissonSection as any,
  "blocks.selection": SelectionSection as any,
  "blocks.carte-remise": Remise as any,
  "blocks.plaisir-gourmet": NosFormules as any,
  "blocks.hero-2": DevenirPartenaireSection as any,
  "blocks.pourquoi-choisir-regalice": AvantagesEntreprise as any,
  "blocks.pour-qui": PourQuiSection as any,
  "blocks.contactez-nous": ContactezNous as any,
  "blocks.faq": FAQ as any, 
  "blocks.formulaire": Formulaire as any,
  "blocks.notre-solution": Solutions as any,
  "blocks.etapes": Etapes as any,
  "blocks.formulaire-contact-agence": FormulaireContactAgence as any,
  "blocks.presentation-contact": PresentationContact as any,
  "blocks.avantages-rapides": AvantagesRapides as any,
  "blocks.nos-formules-gourmet": FormuleSectionGourmet as any,
  "blocks.accordeon-agence": AccordeonAgence as any,
  "blocks.nos-profils": NosProfils as any,
};
